<script setup>
import Spinner from '@/Components/Spinner.vue';
</script>
<template>
    <div class="flex-column flex max-w-full grow justify-center overflow-hidden p-4">
        <div class="loading mb-3 flex items-center justify-center">
            <span class="placeholder chart-placeholder loading-ripple col-12" />
            <spinner class="absolute" />
        </div>
        <div class="loading flex justify-between">
            <span class="placeholder axis-placeholder loading-ripple col-2 rounded-md" />
            <span class="placeholder axis-placeholder loading-ripple col-2 rounded-md" />
            <span class="placeholder axis-placeholder loading-ripple col-2 rounded-md" />
            <span class="placeholder axis-placeholder loading-ripple col-2 rounded-md" />
        </div>
    </div>
</template>

<style scoped>
.chart-placeholder {
    height: 200px;
    border-radius: 8px;
}

.axis-placeholder {
    height: 20px;
}

/* Lighter placeholder color to match SkeletonLoader */
.placeholder {
    background-color: #f1f3f4 !important;
    opacity: 0.8;
}
</style>
